import { render, staticRenderFns } from "./ProcessoWorkflow.vue?vue&type=template&id=7fb09f7d&scoped=true"
import script from "./ProcessoWorkflow.vue?vue&type=script&lang=js"
export * from "./ProcessoWorkflow.vue?vue&type=script&lang=js"
import style0 from "./ProcessoWorkflow.vue?vue&type=style&index=0&id=7fb09f7d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb09f7d",
  null
  
)

export default component.exports